import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["supplierSelect", "purchasesSelect", "selectedPurchases"]

    connect() {
        if (this.supplierSelectTarget.value) {
            this.loadPurchases()
        }
    }

    loadPurchases() {
        const supplierId = this.supplierSelectTarget.value
        if (!supplierId) {
            this.purchasesSelectTarget.innerHTML = ""
            return
        }
        fetch(`/bills/supplier_purchases?supplier_id=${supplierId}`)
            .then(response => response.json())
            .then(data => {
                this.purchasesSelectTarget.innerHTML = ""
                data.forEach(purchase => {
                    const option = document.createElement("option")
                    option.value = purchase.id
                    option.text = `${purchase.reference} - Date: ${purchase.purchase_date} - Balance: ${(purchase.balance_amount)}`

                    option.dataset.status = purchase.status
                    option.dataset.paymentStatus = purchase.payment_status
                    option.dataset.paidAmount = purchase.paid_amount
                    option.dataset.balanceAmount = purchase.balance_amount
                    option.dataset.purchaseDate = purchase.purchase_date
                    this.purchasesSelectTarget.appendChild(option)
                })
            })
    }

    updateSelectedPurchases() {
        const selectedOptions = Array.from(this.purchasesSelectTarget.selectedOptions)
        if (selectedOptions.length === 0) {
            this.selectedPurchasesTarget.innerHTML = "<div class='text-muted'>No purchases selected.</div>"
            return
        }
        let rows = selectedOptions.map(option => {
            const status = option.dataset.status || "-"
            const purchaseDate = option.dataset.purchaseDate || "-"
            const paymentStatus = option.dataset.paymentStatus || "-"
            const paidAmount = option.dataset.paidAmount || "-"
            const balanceAmount = option.dataset.balanceAmount || "-"
            return `
        <tr>
          <td><strong>${option.text}</strong></td>
          <td>${purchaseDate}</td>
          <td><span class="badge badge-primary">${status}</span></td>
          <td><span class="badge badge-info">${paymentStatus}</span></td>
          <td class="text-success">${paidAmount}</td>
          <td class="text-danger">${balanceAmount}</td>
        </tr>
      `
        }).join("")
        this.selectedPurchasesTarget.innerHTML = `
      <div class="table-responsive">
        <table class="table table-bordered table-sm mb-0">
          <thead>
            <tr>
              <th>Reference</th>
              <th>Date</th>
              <th>Status</th>
              <th>Payment Status</th>
              <th>Paid</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            ${rows}
          </tbody>
        </table>
      </div>
    `
    }
}
